import { FC } from 'react';
import { classnames } from '@/utils/classnames';

interface IFlipCardFrontFaceProps {
  children: React.ReactNode;
  className?: string;
}
export const FlipCardFrontFace: FC<IFlipCardFrontFaceProps> = ({
  children,
  className,
}) => {
  return (
    <div
      className={classnames(
        'absolute inset-0 h-full w-full rounded-xl [backface-visibility:hidden]',
        className
      )}
    >
      {children}
    </div>
  );
};
